import { Layout } from "antd";
import Loading from "components/Loading";
import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import AppHeader from "./AppHeader";

export default function Base(): React.ReactElement {
  return (
    <Layout>
      <AppHeader />
      <Suspense fallback={<Loading />}>
        <Outlet />
      </Suspense>
    </Layout>
  );
}
